import { CUSTOM_COLUMN_PREFIX } from '../../columnsConfiguration/constants';

export const getValueCaptionItem = (id, caption) => {
  return {
    customStyle: undefined,
    id,
    idForFilter: id,
    idString: id,
    value: caption,
    valueCaption: caption,
    valueForFilter: caption,
    valueKey: id,
    valueKeyForFilter: id,
    valueToDisplay: caption,
  };
};

export const getTranslatedCustomValueCaption = (texts, fieldName, id) => {
  if (!texts || typeof texts !== 'object' || !fieldName || !id) {
    return null;
  }
  return texts[`${CUSTOM_COLUMN_PREFIX}${fieldName}.${id}`] || null;
};

export const getCustomHeaderName = (texts, fieldName) => {
  if (!texts || typeof texts !== 'object' || !fieldName) {
    return null;
  }
  return texts[`${CUSTOM_COLUMN_PREFIX}${fieldName}`] || null;
};
